import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@material-ui/core";
import { convertToLocaleDateTime } from "../functionalComponents/FormatDateTimeToLocale";
import moment from "moment";

const ReasonCodeTable = ({ reasonCodeList, tableLoading, error }) => {
  return (
    <TableContainer component={Paper} style={{ borderRadius: "8px" }}>
      <Table>
        <TableHead style={{ backgroundColor: "#ffe4cc" }}>
          <TableRow>
            {[
              "Event Description",
              "Reason Code ID",
              "Reason Code Description",
              "Comment",
              "User",
              "Timestamp",
            ].map((head) => (
              <TableCell
                key={head}
                style={{ fontWeight: "bold", fontSize: "13px" }}
              >
                {head}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {tableLoading ? (
          <TableBody>
            <TableRow>
              <TableCell colSpan={6} align="center">
                <CircularProgress color="primary" thickness={7} />
              </TableCell>
            </TableRow>
          </TableBody>
        ) : error ? (
          <TableBody>
            <TableRow
              style={{
                border: "2px solid rgb(255,0,0)",
                backgroundColor: "rgb(255,240,240)",
                textAlign: "center",
                padding: "0.8rem",
                fontSize: "0.875rem",
              }}
            >
              <TableCell colSpan={6} align="center" style={{ padding: "10px" }}>
                Something went wrong. Please try again later.
              </TableCell>
            </TableRow>
          </TableBody>
        ) : reasonCodeList?.length > 0 ? (
          <TableBody>
            {reasonCodeList.map((row, index) => (
              <TableRow key={index}>
                <TableCell style={{ fontSize: "12px" }}>
                  {row?.eventDescription || ""}
                </TableCell>
                <TableCell style={{ fontSize: "12px" }}>
                  {row?.reasonCode || ""}
                </TableCell>
                <TableCell style={{ fontSize: "12px" }}>
                  {row?.reasonDescription || ""}
                </TableCell>
                <TableCell style={{ fontSize: "12px" }}>
                  {row?.comment || ""}
                </TableCell>
                <TableCell style={{ fontSize: "12px" }}>
                  {row?.lastUpdatedBy || ""}
                </TableCell>
                <TableCell style={{ fontSize: "12px" }}>
                  {/* {new Date(row.lastUpdatedDate)
                                        .toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })
                                        .replace(",", "")
                                        .toUpperCase()}{" "}
                                    {new Date(row.lastUpdatedDate)
                                        .toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false })} */}
                  {/* {row?.lastUpdatedDate
                    ? `${moment(
                        convertToLocaleDateTime(row?.lastUpdatedDate)
                      ).format("Do MMM YYYY HH:mm:ss")}`
                    : "NA"} */}
                  {row?.lastUpdatedDate
                    ? convertToLocaleDateTime(
                        row?.lastUpdatedDate
                      ).toUpperCase()
                    : ""}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        ) : (
          <TableBody>
            <TableRow>
              <TableCell colSpan={6} align="center">
                No data available
              </TableCell>
            </TableRow>
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
};

export default ReasonCodeTable;
